<cm-section>
    <ng-container cm-icon><i class="far fa-paperclip"></i></ng-container>
    <ng-container cm-title>Files</ng-container>
    <ng-container cm-content>
        <cm-attachments [item]="$item()" [assignmentTypes]="$assignmentTypes()" [canDownload]="$canDownload()" class="cm-files"></cm-attachments>
    </ng-container>
</cm-section>
